
import { useLanguage } from "@/app/LanguageContext"
type Language = "en" | "am" | "ti";

type TranslationValue = Record<Language, string>;


export function useTranslate() {
  const { language } = useLanguage() as { language: Language };

  const t = (key: keyof typeof translation) => {
    const value = translation[key];
    return value?.[language] || value?.en || key;
  };

  return { t };
}


const translation: Record<string, TranslationValue>  = {
  "home": {
      "en": "Home",
      "am": "መነሻ ገፅ",
      "ti": "ዋና ገፅ"
  },
  "about": {
      "en": "About",
      "am": "ስለ እኛ",
      "ti": "ብዛዕባና"
  },
  "vision_and_mission": {
      "en": "Vision and Mission",
      "am": "ራዕይና ተልዕኮ",
      "ti": "ራእይን ልኡክን"
  },
  "vision": {
    "en": "Vision",
    "am": "ራዕይ",
    "ti": "ራእይ"
},
"mission": {
    "en": "Mission",
    "am": "ተልዕኮ",
    "ti": "ልኡክን"
},
  "value": {
      "en": "Value",
      "am": "እሴት",
      "ti": "ክብርታት"
  },
  "president_message": {
      "en": "President Message",
      "am": "የፕሬዚዳንት መልዕክት",
      "ti": "መልእኽቲ ፕረዚደንት"
  },
  "people": {
      "en": "People",
      "am": "ህዝብ",
      "ti": "ህዝቢ"
  },
  "history": {
      "en": "History",
      "am": "ታሪክ",
      "ti": "ታሪኽ"
  },
  "geography": {
      "en": "Geography",
      "am": "ጂኦግራፊያ",
      "ti": "ጂኦግራፊ"
  },
  "regional_structure": {
      "en": "Regional Structure",
      "am": "ክልላዊ መዋቅር",
      "ti": "ክልላዊ መዋቕር"
  },
  "government": {
      "en": "Government",
      "am": "መንግሥት",
      "ti": "መንግስቲ"
  },
  "regional_sectors": {
      "en": "Regional Sector/s",
      "am": "ክልላዊ ክፍል/ክፍሎች",
      "ti": "ክልላዊ ቤት-ዕዮ/ታት"
  },
  "towns": {
      "en": "Town/s",
      "am": "ከተማ",
      "ti": "ከተማ/ከተማታት"
  },
  "zones": {
      "en": "Zone/s",
      "am": "ዞን",
      "ti": "ዞባ/ዞባታት"
  },
  "latest_news": {
      "en": "Latest News",
      "am": "የቅርብ ጊዜ ዜናዎች",
      "ti": "እዋናዊ ዜና"
  },
  "news": {
    "en": "News",
    "am": "ዜና",
    "ti": "ዜና"
},
  "tender": {
      "en": "Tender",
      "am": "ጨረታ",
      "ti": "ጨረታ"
  },
  "vacancy": {
      "en": "Vacancy",
      "am": "ክፍት የስራ ቦታ",
      "ti": "ክፍቲ ቦታ ስራሕ"
  },
    "announcement": {
        "en": "Announcement",
        "am": "ማስታወቂያ",
        "ti": "ምልክታ"
    },
    "service": {
        "en": "Service",
        "am": "አገልግሎት",
        "ti": "ግልጋሎት"
    },
    "programs": {
        "en": "Program",
        "am": "ፕሮግራም",
        "ti": "ፕሮግራም"
    },
    "economy": {
        "en": "Economy",
        "am": "ኢኮኖሚ",
        "ti": "ቁጠባ"
    },
    "gallery": {
        "en": "Gallery",
        "am": "ጋለሪ",
        "ti": "ማዕኸን-ስእላት"
    },
    "resources": {
        "en": "Resource/s",
        "am": "መርጃ",
        "ti": "ሰነዳት"
    },
    "projects": {
        "en": "Project/s",
        "am": "ፕሮጀክት",
        "ti": "ፕሮጀክት/ፕሮጀክትታት"
    },
    "contact": {
        "en": "Contact",
        "am": "አድራሻ/ያግኙን",
        "ti": "ርከቡና"
    },
    "special_woreda": {
        "en": "Special Woreda",
        "am": "ልዩ ወረዳ",
        "ti": "ፍሉይ ወረዳ"
    },
    "and": {
        "en": "And",
        "am": "እና",
        "ti": "ን"
    },
    "business": {
        "en": "Business",
        "am": "ንግድ",
        "ti": "ንግዲ"
    },
    "faq": {
        "en": "FAQ(frequently asked questions)",
        "am": "በተደጋጋሚ የሚጠየቁ ጥያቄዎች",
        "ti": "FAQ(ብተደጋጋሚ ዝሕተቱ ሕቶታት)"
    },
    "read_more": {
        "en": "Read More",
        "am": "ተጨማሪ ያንብቡ",
        "ti": "ተወሳኺ ኣንብብ"
    },
    "overview": {
        "en": "Overview",
        "am": "አጠቃላይ እይታ",
        "ti": "ሓፈሻዊ ትሕዝቶ"
    },
    "leadership": {
        "en": "Leadership",
        "am": "አመራር",
        "ti": "መሪሕነት"
    },
    "organizational_structure": {
        "en": "Organizational Structure",
        "am": "የተቋም መዋቅር",
        "ti": "ትካላዊ መዋቕር"
    },
    "administration": {
        "en": "Administration",
        "am": "አስተዳደር",
        "ti": "ምምሕዳር"
    },
    "mayor": {
        "en": "Mayor",
        "am": "ከንቲባ",
        "ti": "ከንቲባ"
    },
    "cabinate_profile": {
        "en": "Cabinate Profile",
        "am": "የካቢኔ መረጃ",
        "ti": "ካቢኔ ፕሮፋይል"
    },
    "city_structure": {
        "en": "City Structure",
        "am": "የከተማ መዋቅር",
        "ti": "መዋቕር ከተማና"
    },
    "council": {
        "en": "Council",
        "am": "ምክር ቤት",
        "ti": "ቤት ምኽሪ"
    },
    "subcity": {
        "en": "Subcity",
        "am": "ክፍለ ከተማ",
        "ti": "ክፍለ ከተማ"
    },
    "information": {
        "en": "Information",
        "am": "መረጃዎች",
        "ti": "ሓበሬታ"
    },
    "offices": {
        "en": "Offices",
        "am": "ቢሮዎች",
        "ti": "ኣብያተ ፅሕፈት"
    },
    "explore": {
        "en": "Explore",
        "am": "ያስሱ",
        "ti": "ይዳህስሱ"
    },
    "explore_services": {
        "en": "Explore Services",
        "am": "አገልግሎቶችን ያስሱ",
        "ti": "ግልጋሎታት ይዳህስሱ"
    },
    "radiation_and_nuclear_sector": {
        "en": "Radiation And nuclear sector",
        "am": "ጨረርና ኑክሌር ክፍል",
        "ti": "ዘፈር ጨረርን ኒዩክለራዊ ፅላትን"
    },
    "industry_sector": {
        "en": "Industry Sector",
        "am": "ኢንዱስትሪ ክፍል",
        "ti": "ዘፈር ኢንዳስትሪ"
    },
    
      "regulation_and_standards": {
          "en": "Regulation And Standards",
          "am": "ደንቦችና መመሪያዎች",
          "ti": "መምርሒታትን ደንቢታትን"
      },
      "publications": {
          "en": "Publications",
          "am": "ህትመቶች",
          "ti": "ውፅኢት ሕትመት"
      },
      "reports": {
          "en": "Reports",
          "am": "ሪፖርቶች",
          "ti": "ፀብፃባት"
      },
      "other_resources": {
          "en": "other resources",
          "am": "ሌሎች መረጃዎች",
          "ti": "ካልኦት ፀጋታት"
      },
      "programs_and_initiatives": {
          "en": "Programs and Initiatives",
          "am": "ፕሮግራሞችና ተነሳሽነቶች",
          "ti": "መደባትን ተበግሶታትን"
      },
      "upcoming_events": {
          "en": "upcoming Events",
          "am": "መጪ ሁነቶች",
          "ti": "መፃኢ ፍፃመታት"
      },
      "vacancy_announcements": {
          "en": "Vacancy Announcements",
          "am": "የስራ ቦታ ማስታወቂያዎች",
          "ti": "ክፍቲ ቦታ ስራሕ"
      },
      "contact_us": {
          "en": "Contact us",
          "am": "ያግኙን",
          "ti": "ርኸቡና"
      },
      "economy_and_business": {
          "en": "Economy And Bussiness",
          "am": "ኢኮኖሚና ንግድ",
          "ti": "ንግዲን ቁጠባን"
      },
      "program_and_projects": {
          "en": "Program and Projects",
          "am": "ፕሮግራሞችና ፕሮጀክቶች",
          "ti": "ፕሮግራማትን ፕሮጀክትታትን"
      },
      "all_services": {
          "en": "All Services",
          "am": "ሁሉም አገልግሎቶች",
          "ti": "ግልጋሎታት"
      },
      "all_news": {
          "en": "All News",
          "am": "ዜናዎች",
          "ti": "ዜና"
      },
      "stay_up_to_date": {
          "en": "Stay Up-to-date with the Latest Insights and Stories: Explore News, Developments, and Perspectives from Across the Region.",
          "am": "ከአዳዲስ ገጽታዎችና ዜናዎች ጋር ዘመናዊ ይቆዩ፣ ከክልሉ የሚመጡ እይታዎችና እንቅስቃሴዎችን ያስሱ",
          "ti": "እዋናዊ ርድኢታትን ዛንታታትን ክትከታተሉ ትኽእሉ ኢኹም፤ ካብ መላእ ክልል ዝመጽእ ዜናታት፡ ምዕባለታትን ኣረኣእያታትን ዳህሰሱ"
      },
      "our_partners": {
          "en": "Our Partners",
          "am": "አጋሮቻችን",
          "ti": "መዳርግቲ ኣካላት"
      },
      "have_any_questions": {
          "en": "Have any questions ?",
          "am": "ጥያቄ አለዎት?",
          "ti": "ሕቶታት ምስ ዝህልወኩም"
      },
      "subscribe": {
          "en": "Subscribe",
          "am": "ይመዝገቡ",
          "ti": "ሰብስክራይብ ግበሩ"
      },
      "join_newsletter": {
          "en": "Join our newsletter to stay up to date on features and releases.",
          "am": "ስለ አዳዲስ ባህሪያትና እድሳቶች ለመወቅ በዜና መዝገባችን ይቀላቀሉ",
          "ti": "ብዛዕባ ፍሉይን ሓደሽቲ ነገራትን ንምርካብ ኣብ ዜናና ተፀንበሩ"
      },
      "important_links": {
          "en": "Important Links",
          "am": "አስፈላጊ አገናኞች",
          "ti": "ኣገደስቲ መላግቦታት"
      },
      "enter_your_email": {
          "en": "Enter your email",
          "am": "ኢሜይልዎን ያስገቡ",
          "ti": "ኢመይልኩም ኣእትዉ"
      },
      "copyright": {
          "en": "@ 2025 Powered by MInT. Developed by 360Ground. All rights reserved.",
          "am": "@2025 በ MInT ተዘጋጀ፣ በ 360Ground ተዘረጋ። ሁሉም መብቶች የተጠበቁ ናቸው።",
          "ti": "2025 ብ MInT ዝተሰርሕ። ብ 360Ground ዝተዳለወ። ኩሉ መሰላት ዝተሓለወ እዩ።"
      },
      "privacy_policy": {
          "en": "Privacy Policy",
          "am": "የግል የመረጃ ፖሊሲ",
          "ti": "ፖሊሲ ውልቃዊ ሓበሬታ"
      },
      "terms_of_service": {
          "en": "Terms of Service",
          "am": "የአገልግሎት ውሎች",
          "ti": "ውዕሊ ግልግሎት"
      },
      "cookies_settings": {
          "en": "Cookies Settings",
          "am": "ኩኪዎች ማዋቀር",
          "ti": "ማዋቀር ኩኪዎች"
      },
      "ethiopia_technology_authority": {
          "en": "Ethiopia Technology Authority",
          "am": "የኢትዮጵያ ቴክኖሎጂ ባለሥልጣን",
          "ti": "በዓል መዚ ቴክኖሎጂ ኢትዮጵያ"
      },
      "explore_resources": {
          "en": "Explore our collection of resources including reports, presentations, and more.",
          "am": "ሪፖርቶች፣ ማቅረቢያዎችና ሌሎች ሀብቶችን ያስሱ",
          "ti": "ፀብፃባት፡ ትልምታት፣ ሰነዳትን ካልኦት ፅሑፋትን ይዳህስሱ።"
      },
      
        "category": {
            "en": "Category",
            "am": "ምድብ",
            "ti": "መደብ"
        },
        // 
        "reset_filters": {
            "en": "Reset Filters",
            "am": "ማጣሪያዎችን እንደነበር መልስ",
            "ti": "ማጣሪያዎችን እንደነበር መልስ"
        },
        "filter": {
            "en": "Filter",
            "am": "ማጣሪያ",
            "ti": "ማጣሪያ"
        },
        "moto": {
            "en": "Moto",
            "am": "ሞቶ",
            "ti": "ሞቶ"
        },
        "file_type": {
            "en": "File type",
            "am": "የፋይል አይነት",
            "ti": "ዓይነት ፋይል"
        },
        "date": {
            "en": "Date",
            "am": "ቀን",
            "ti": "ዕለት"
        },
        "title": {
            "en": "Title",
            "am": "ርዕስ",
            "ti": "ርእሲ"
        },
        "search": {
            "en": "Search",
            "am": "ፈልግ",
            "ti": "ኣልሽ"
        },
        "total_results": {
            "en": "Total results",
            "am": "ጠቅላላ ውጤቶች",
            "ti": "ጠቕላላ ውፅኢት"
        },
        "uploaded_on": {
            "en": "Uploaded on",
            "am": "ተሰቀለ በ",
            "ti": "ስቐል"
        },
        "download": {
            "en": "Download",
            "am": "አውርድ",
            "ti": "ኣውርድ"
        },
        "preview": {
            "en": "Preview",
            "am": "ቅድመ እይታ",
            "ti": "ዳህስስ"
        },
        "past_events": {
            "en": "Past Events",
            "am": "ያለፉ ሁነቶች",
            "ti": "ሕሉፍ ፍፃመታት"
        },
        "current_events": {
            "en": "Current Events",
            "am": "አሁን የሚካሄዱ ሁነቶች",
            "ti": "እዋናዊ ፍፃመታት"
        },
        "upcoming_events_alt": {
            "en": "upcoming Events",
            "am": "ቀጣይ ሁነቶች",
            "ti": "መፃኢ ፍፃመታት"
        },
        "sort_by": {
            "en": "Sort by",
            "am": "ቅደም ተከተል በ",
            "ti": "ብ ስራዕ"
        },
        "sort": {
            "en": "Sort",
            "am": "ቅደም ተከተል",
            "ti": "ስራዕ"
        },
        "destination_for_job_seekers": {
            "en": "Destination For Job Seekers.",
            "am": "የስራ ፈላጊዎች መድረክ",
            "ti": "ማዕኸን ደለይቲ ስራሕ"
        },
        "type": {
            "en": "type",
            "am": "አይነት",
            "ti": "ዓይነት"
        },
        "official_image_gallery": {
            "en": "Official Image Gallery: Capturing Our Progress and Heritage",
            "am": "ኦፊሴላዊ የምስል ጋለሪ፣ የእድገታችንን እና ቅርስነታችንን የሚያሳይ",
            "ti": "ወግዓዊ ቤተ-መዘክር ምስሊ፡ መቕረፀ ምዕባለናን ቅርስታትናን"
        },
        "contact_and_support": {
            "en": "Contact & Support",
            "am": "ያግኙና ድጋፍ",
            "ti": "ርኸብ፣ደግፍ"
        },
        "we_are_here_to_assist": {
            "en": "We're here to assist you. don't hesitate to reach out.",
            "am": "እኛ ለመርዳትዎ እዚህ ነን፣ እባክዎን ያግኙን።",
            "ti": "ታይ ክንሕግዘኩም?"
        },
        "send_feedback": {
            "en": "Send us your feedback",
            "am": "አስተያየትዎን ይላኩልን",
            "ti": "ርኢቶኹም ሃቡና"
        },
        "get_in_touch": {
            "en": "Get in touch with us for more information.",
            "am": "ለተጨማሪ መረጃ ያግኙን",
            "ti": "ንተወሳኺ ሓበሬታ ርኸቡና"
        },
        "get_direction": {
            "en": "get direction",
            "am": "አቅጣጫ ያግኙ",
            "ti": "ኣንፈት ርኸብ"
        },
        "submit_feedback": {
            "en": "Submit Feedback",
            "am": "አስተያየት ይላኩ",
            "ti": "ርኢቶ ኣቕርብ"
        },
        "press_release": {
            "en": "Press Release",
            "am": "ጋዜጣ መግለጫዊ",
            "ti": "ጋዜጣዊ መግለፂ"
        },
        "interview": {
            "en": "Interview",
            "am": "ቃለ መጠይቅ",
            "ti": "ቃለ መሕተት"
        },
        "international_relation": {
            "en": "International Relation",
            "am": "ዓለም አቀፍ ግንኙነት",
            "ti": ""
        },
        "speech": {
            "en": "Speech",
            "am": "ንግግር",
            "ti": "መደረ"
        },
        "vacancy_application": {
            "en": "Vacancy Application",
            "am": "የስራ ቦታ መመዝገቢያ",
            "ti": "ቅጥዒ መመልከቲ ክፍቲ ስራሕ መደብ"
        },
        "apply_here": {
            "en": "Apply here",
            "am": "እዚህ ያመልክቱ",
            "ti": "ኣብዚ ኣመልክት"
        },
        
          "submit_application": {
              "en": "Submit Application",
              "am": "መመዝገቢያዎትን ይላኩ",
              "ti": "መመልከቲ ኣቕርብ"
          },
          "upload": {
              "en": "upload",
              "am": "ይጫኑ",
              "ti": "ፅዓን"
          },
          "choose_file": {
              "en": "Choose File",
              "am": "ፋይል ይምረጡ",
              "ti": "ፋይል ድለ"
          },
          "no_file_chosen": {
              "en": "No file choosen",
              "am": "ምንም ፋይል አልተመረጠም",
              "ti": "ፋይል ኣይተመርፀን"
          },
          "thought_and_opinion": {
              "en": "Thought and Opinion",
              "am": "ሀሳብና አስተያየት",
              "ti": "ሓሳብን ርኢቶን"
          },
          "optional": {
              "en": "optional",
              "am": "አማራጭ",
              "ti": "መማረፂ"
          },
          "emergency_numbers": {
              "en": "Emergency Numbers",
              "am": "የአደጋ ጊዜ ቁጥሮች",
              "ti": "ቑፅሪ ህፁፅ እዋን"
          },
          "contact_info": {
              "en": "Contact Info",
              "am": "መገኛ",
              "ti": "ናይ ተፀዋዒ ሓበሬታ"
          },
          "contact_and_collaborate": {
              "en": "Contact Us & We Can Work Together",
              "am": "እኛን ያግኙ እና በአንድነት እንሰራ",
              "ti": "ብሓባር ክንሰርሕ ርኸቡና"
          },
          "no_resources_found": {
              "en": "No resources found matching your filters.",
              "am": "ከማጣሪያዎችን ጋር የሚዛመዱ መረጃዎች አልተገኙም",
              "ti": "ዝደለዩዎ ፋይል ኣይተረኽበን"
          },
          "relevance": {
              "en": "relevance",
              "am": "ተዛማጅነት",
              "ti": "ተዛማድነት"
          },
          "phone_number": {
              "en": "Phone Number",
              "am": "ስልክ ቁጥር",
              "ti": "ቑፅሪ ስልኪ"
          },
          "email_address": {
              "en": "Email Address",
              "am": "ኢሜይል አድራሻ",
              "ti": "ኤሜይል"
          },
          "complain": {
              "en": "complain",
              "am": "ቅሬታ",
              "ti": "ጥርዓን"
          },
          "successfully_submitted": {
              "en": "successfully submitted",
              "am": "በትክክል ተልኯል",
              "ti": "ብትኽክል ተሰዲዱ"
          },
          "latest_announcements": {
              "en": "Latest Announcements",
              "am": "የቅርብ ማስታወቂያዎች",
              "ti": "እዋናዊ ምልክታታት"
          },
          "share": {
              "en": "share",
              "am": "አጋራ",
              "ti": "ኣማቐል"
          },
          "view_more": {
              "en": "View More",
              "am": "ተጨማሪ ይመልከቱ",
              "ti": "ተወሳኺ ዳህስስ"
          },
          "video_playlists": {
              "en": "Video Playlists",
              "am": "የቪዲዮ ዝርዝሮች",
              "ti": ""
          },
          "copy_url": {
              "en": "copy url",
              "am": "አድራሻን ቅዳ",
              "ti": ""
          },
          "see_more": {
              "en": "See more",
              "am": "ተጨማሪ ይመልከቱ",
              "ti": "ተወሳኺ ርአ"
          },
          "first_page": {
              "en": "First Page",
              "am": "መጀመሪያ ገፅ",
              "ti": "ቐዳማይ ገፅ"
          },
          "last_page": {
              "en": "Last Page",
              "am": "መጨረሻ ገፅ",
              "ti": "ናይ መወዳእታ ገፅ"
          },
          "next_page": {
              "en": "Next Page",
              "am": "ቀጣይ ገፅ",
              "ti": "ቀፃሊ ገፅ"
          },
            //  Start typing and press Search 
            "start_typing_and_press_search":{
                "en":"Search for Resource,Services and News",
                "am": "መርጃዎች ፣ አገልግሎቶችን እና ዜናን ይፈልጉ",
                "ti": "ጸጋታት፣ኣገልግሎትን ዜናን ምድላይ",
              },
            //   Type to search
            "type_to_search":{
                "en":"Type to search",
                "am": "ለመፈለግ ይተይቡ",
                "ti": "",
              },
            //   No result found
            "no_result_found":{
                "en":"No result found",
                "am": "ምንም አልተገኘም",
                "ti": "",
              },
              "name":{
                "en":"Name",
                "am": "ስም",
                "ti": "ሽም",
              },
              "email":{
                "en":"Email",
                "am": "ኢሜይል",
                "ti": "ኢመይል",
              },
              "message":{
                "en":"Message",
                "am": "መልእክት",
                "ti": "መልእኽቲ",
              },
              "thank_you_message":{
                "en":"Thanks For Your Feedback",
                "am":'ለአስተያየትዎ እናመሰግናለን',
                "ti":"ንዝሃብኩምና ርእይቶ የቐንየልና"
              },
              "internal_boards":{
                "en":"Internal Board",
                "am":"የውስጥ ሰሌዳ",
                "ti":"ውሽጣዊ ቦርድ",
              },
              "internal_board":{
                "en":"Internal Board",
                "am":"የውስጥ ሰሌዳ",
                "ti":"ውሽጣዊ ቦርድ",
              },
              "back_to_home":{
                "en":"Back To Home",
                "am":"መነሻ ገፅ ይመልከቱ",
                "ti":"መነሻ ገፅ ይመልከቱ",
              },
              "enter_credentials":{
                "en":"Enter Credentials",
                "am":"ሚስጥራዊ መረጃ ያስገቡ",
                "ti":"ምስጢራዊ ሓበሬታ ኣእቱ",
              },
              "username_or_email":{
                "en":"Username or Email",
                "am":"የተጠቃሚ ስም ወይም ኢሜል",
                "ti":"ስም ተጠቃሚ ወይ ኢመይል",
              },
              "enter_username_or_email":{
                "en":"Enter Username or Email",
                "am":"የተጠቃሚ ስም ወይም ኢሜል ይስገቡ",
                "ti":"ስም ተጠቃሚ ወይ ኢመይል ኣእቱ",
              },
              "password":{
                "en":"Password",
                "am":"የይለፍ ቁጥር",
                "ti":"የይለፍ ቁጥር",
              },
              "enter_password":{
                "en":"Enter Password",
                "am":"የይለፍ ቁጥር ይስገቡ",
                "ti":"የይለፍ ቁጥር ኣእቱ",
              },
              "sign_in":{
                "en":"Sign In",
                "am":"ይግቡ",
                "ti":"ኣእትው",
              },
              "post_reply":{
                "en":"Post Reply",
                "am":"ምላሽ ለጥፍ",
                "ti":"መልሲ ፖስት",
              }
            
        }

 